// extracted by mini-css-extract-plugin
export default {"BudgetBaseComponent":"BudgetBaseComponent_BudgetBaseComponent__0T3P2"};